var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header",class:{crosswise_header: !_vm.vertical}},[_c('div',[_vm._v("支付中心")])])
}
var staticRenderFns = []

export { render, staticRenderFns }